/* Seyacare — theme interactions (cart, drawers, popups, quiz) */
(function () {
  "use strict";
  var T = window.SeyaTheme || {};
  var routes = T.routes || {};

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = (cents / 100);
    var fmt = T.moneyFormat || "{{ amount }} €";
    function withComma(n) { return n.toFixed(2).replace(".", ","); }
    function withDot(n) { return n.toFixed(2); }
    function noDecimals(n) { return Math.round(n).toString(); }
    function spaceSep(n) { return n.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, " "); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case "amount": return withDot(value);
        case "amount_no_decimals": return noDecimals(value);
        case "amount_with_comma_separator": return withComma(value);
        case "amount_no_decimals_with_comma_separator": return noDecimals(value);
        case "amount_with_space_separator": return spaceSep(value);
        case "amount_with_apostrophe_separator": return withDot(value).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
        default: return withComma(value);
      }
    });
  }

  var toastTimer;
  function toast(msg) {
    var el = $("#SeyaToast");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove("show"); }, 3200);
  }

  /* ---------- generic drawer/modal ---------- */
  function openEl(el) { if (el) el.classList.add("open"); document.body.style.overflow = "hidden"; }
  function closeEl(el) { if (el) el.classList.remove("open"); document.body.style.overflow = ""; }

  /* ---------- header scroll ---------- */
  var header = $("#SeyaHeader");
  var logo = $("#SeyaLogo");
  var isHome = document.body.classList.contains("is-home");
  function onScroll() {
    var scrolled = window.scrollY > 20;
    if (header) header.classList.toggle("scrolled", scrolled);
    if (logo) {
      var overHero = isHome && !scrolled;
      if (overHero) {
        logo.classList.add("text-[#E7D3B8]");
        logo.classList.remove("text-[#23481a]");
        logo.style.textShadow = "0 1px 10px rgba(0,0,0,0.35)";
      } else {
        logo.classList.remove("text-[#E7D3B8]");
        logo.classList.add("text-[#23481a]");
        logo.style.textShadow = "";
      }
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- mobile menu ---------- */
  var menuDrawer = $("[data-menu-drawer]"), menuOverlay = $("[data-menu-overlay]");
  function menuOpen() { openEl(menuDrawer); openEl(menuOverlay); }
  function menuClose() { closeEl(menuDrawer); closeEl(menuOverlay); }
  $all("[data-menu-open]").forEach(function (b) { b.addEventListener("click", menuOpen); });
  $all("[data-menu-close]").forEach(function (b) { b.addEventListener("click", menuClose); });
  if (menuOverlay) menuOverlay.addEventListener("click", menuClose);

  /* ---------- search ---------- */
  var searchModal = $("[data-search-modal]");
  $all("[data-search-open]").forEach(function (b) { b.addEventListener("click", function () { openEl(searchModal); var i = searchModal && searchModal.querySelector("input"); if (i) setTimeout(function () { i.focus(); }, 100); }); });
  $all("[data-search-close]").forEach(function (b) { b.addEventListener("click", function () { closeEl(searchModal); }); });

  /* ---------- cart ---------- */
  var cartDrawer = $("[data-cart-drawer]"), cartOverlay = $("[data-cart-overlay]");
  var cartItemsEl = $("[data-cart-items]"), cartEmptyEl = $("[data-cart-empty]"), cartFooterEl = $("[data-cart-footer]"), cartSubtotalEl = $("[data-cart-subtotal]");

  function cartOpen() { openEl(cartDrawer); openEl(cartOverlay); renderCart(); }
  function cartClose() { closeEl(cartDrawer); closeEl(cartOverlay); }
  $all("[data-cart-open]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); cartOpen(); }); });
  $all("[data-cart-close]").forEach(function (b) { b.addEventListener("click", cartClose); });
  if (cartOverlay) cartOverlay.addEventListener("click", cartClose);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { cartClose(); menuClose(); closeEl(searchModal); }
  });

  function iconSvg(name) {
    var p = {
      minus: '<line x1="5" y1="12" x2="19" y2="12"/>',
      plus: '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>',
      trash: '<path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>'
    };
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">' + (p[name] || "") + "</svg>";
  }

  function setCount(n) {
    $all("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.classList.add("flex"); el.classList.remove("hidden"); }
      else { el.classList.add("hidden"); el.classList.remove("flex"); }
    });
  }

  function renderCart() {
    fetch(routes.cart_url + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (!cartItemsEl) return;
        if (cart.item_count === 0) {
          cartItemsEl.innerHTML = "";
          if (cartEmptyEl) cartEmptyEl.hidden = false;
          if (cartFooterEl) cartFooterEl.hidden = true;
          return;
        }
        if (cartEmptyEl) cartEmptyEl.hidden = true;
        if (cartFooterEl) cartFooterEl.hidden = false;
        if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);
        cartItemsEl.innerHTML = cart.items.map(function (item, i) {
          var img = item.image ? item.image.replace(/(\.[^.\/]+)(\?.*)?$/, "_160x$1$2") : "";
          return '' +
          '<div class="flex gap-4" data-cart-line="' + (i + 1) + '" data-testid="cart-item-' + item.handle + '">' +
            '<a href="' + item.url + '"><img src="' + img + '" alt="" class="w-20 h-20 object-cover rounded-xl"></a>' +
            '<div class="flex-1 min-w-0">' +
              '<p class="font-medium text-sm text-primary truncate">' + item.product_title + '</p>' +
              '<p class="text-sm text-muted-foreground mb-2">' + formatMoney(item.final_price) + '</p>' +
              '<div class="flex items-center gap-2">' +
                '<button class="w-7 h-7 rounded-full border border-border flex items-center justify-center hover:bg-muted transition-colors" data-qty-dec data-testid="decrease-' + item.handle + '" aria-label="Diminuer">' + iconSvg("minus") + '</button>' +
                '<span class="w-6 text-center text-sm">' + item.quantity + '</span>' +
                '<button class="w-7 h-7 rounded-full border border-border flex items-center justify-center hover:bg-muted transition-colors" data-qty-inc data-testid="increase-' + item.handle + '" aria-label="Augmenter">' + iconSvg("plus") + '</button>' +
              '</div>' +
            '</div>' +
            '<button class="text-muted-foreground hover:text-destructive transition-colors self-start" data-line-remove data-testid="remove-' + item.handle + '" aria-label="Retirer">' + iconSvg("trash") + '</button>' +
          '</div>';
        }).join("");

        $all("[data-cart-line]", cartItemsEl).forEach(function (row) {
          var line = row.getAttribute("data-cart-line");
          var qtyEl = row.querySelector("span");
          var qty = parseInt(qtyEl.textContent, 10);
          row.querySelector("[data-qty-dec]").addEventListener("click", function () { changeLine(line, qty - 1); });
          row.querySelector("[data-qty-inc]").addEventListener("click", function () { changeLine(line, qty + 1); });
          row.querySelector("[data-line-remove]").addEventListener("click", function () { changeLine(line, 0); });
        });
      })
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    fetch(routes.cart_change_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function () { renderCart(); }).catch(function () {});
  }

  function addToCart(id, quantity) {
    return fetch(routes.cart_add_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: id, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest(".seya-add-form");
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput || !idInput.value) { toast("Produit indisponible"); return; }
    addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1)
      .then(function () { toast("Ajouté au panier 🌿"); cartOpen(); })
      .catch(function (err) { toast((err && err.description) || "Erreur, réessayez"); });
  });

  /* ---------- newsletter popup ---------- */
  (function () {
    var KEY = "seya_nl_seen";
    var modal = $("[data-nl-modal]");
    if (!modal) return;
    var suppressed = ["/checkout", "/cart"];
    var path = window.location.pathname;
    $all("[data-nl-close]").forEach(function (b) { b.addEventListener("click", function () { localStorage.setItem(KEY, "1"); closeEl(modal); }); });
    var success = modal.querySelector("[data-testid='newsletter-popup-success']");
    if (success) { localStorage.setItem(KEY, "1"); return; }
    try { if (localStorage.getItem(KEY)) return; } catch (e) { return; }
    if (suppressed.some(function (r) { return path.indexOf(r) === 0; })) return;
    setTimeout(function () { openEl(modal); }, 7000);
  })();

  /* ---------- cookie consent ---------- */
  (function () {
    var KEY = "seya_cookie_consent";
    var bar = $("[data-cookie]");
    if (!bar) return;
    try { if (localStorage.getItem(KEY)) return; } catch (e) {}
    bar.hidden = false;
    function persist(choice) {
      try { localStorage.setItem(KEY, JSON.stringify(choice)); } catch (e) {}
      bar.hidden = true;
    }
    var accept = bar.querySelector("[data-cookie-accept]"), refuse = bar.querySelector("[data-cookie-refuse]");
    if (accept) accept.addEventListener("click", function () { persist({ analytics: true, date: new Date().toISOString() }); });
    if (refuse) refuse.addEventListener("click", function () { persist({ analytics: false, date: new Date().toISOString() }); });
  })();

  /* ---------- quiz ---------- */
  (function () {
    var root = $("[data-quiz]");
    if (!root) return;
    var steps, needsMap, prods;
    try {
      steps = JSON.parse($("#QuizSteps").textContent);
      needsMap = JSON.parse($("#QuizNeeds").textContent);
      prods = JSON.parse($("#QuizProducts").textContent);
    } catch (e) { return; }

    var state = { step: 0, scores: {}, finished: false };
    var qTitle = root.querySelector("[data-quiz-title]");
    var qSub = root.querySelector("[data-quiz-sub]");
    var qBody = root.querySelector("[data-quiz-body]");

    function render() {
      if (!state.finished) {
        var s = steps[state.step];
        qTitle.textContent = s.q;
        qSub.textContent = s.sub;
        var weight = steps.length - state.step;
        var dots = steps.map(function (_, i) { return '<span class="h-1.5 rounded-full transition-all ' + (i <= state.step ? "w-10 bg-secondary" : "w-6 bg-border") + '"></span>'; }).join("");
        var opts = s.options.map(function (opt, i) {
          return '<button data-testid="quiz-step-' + state.step + '-option-' + i + '" data-opt="' + i + '" class="text-left bg-card rounded-2xl p-6 shadow-[0_4px_24px_rgba(42,59,50,0.06)] hover:shadow-[0_12px_40px_rgba(42,59,50,0.12)] hover:-translate-y-1 transition-all font-serif text-lg text-primary">' + opt.label + '</button>';
        }).join("");
        qBody.innerHTML =
          '<div class="flex items-center justify-center gap-2 mb-8">' + dots + '</div>' +
          '<div class="grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto">' + opts + '</div>' +
          (state.step > 0 ? '<div class="text-center mt-8"><button data-quiz-back data-testid="quiz-back" class="inline-flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors text-sm">← Question précédente</button></div>' : "");
        $all("[data-opt]", qBody).forEach(function (b) {
          b.addEventListener("click", function () { choose(s.options[parseInt(b.getAttribute("data-opt"), 10)], weight); });
        });
        var back = qBody.querySelector("[data-quiz-back]");
        if (back) back.addEventListener("click", function () { if (state.step > 0) { state.step--; render(); } });
      } else {
        var ranked = Object.keys(state.scores).sort(function (a, b) { return state.scores[b] - state.scores[a]; });
        var topSlug = ranked[0] || Object.keys(needsMap)[0];
        var secondSlug = ranked[1];
        var handles = [];
        (needsMap[topSlug] || []).concat(needsMap[secondSlug] || []).forEach(function (h) { if (handles.indexOf(h) === -1) handles.push(h); });
        handles = handles.slice(0, 3);
        qTitle.textContent = "Voici notre recommandation";
        qSub.textContent = "Une routine naturelle pensée pour vous.";
        var cards = handles.map(function (h) {
          var p = prods[h];
          if (!p) return "";
          return '' +
          '<div class="group">' +
            '<a href="' + p.url + '" class="block overflow-hidden rounded-3xl bg-[#EEF5ED] relative"><img src="' + p.image + '" alt="' + p.title + '" class="w-full aspect-[4/5] object-contain p-8 mix-blend-multiply transition-transform duration-700 group-hover:scale-105"></a>' +
            '<h3 class="font-serif font-bold text-lg text-primary leading-tight mt-4">' + p.title + '</h3>' +
            '<div class="flex items-baseline gap-2 mt-2"><span class="text-lg text-primary font-medium">' + p.price + '</span></div>' +
            '<form action="' + routes.cart_add_url + '" method="post" class="seya-add-form mt-3"><input type="hidden" name="id" value="' + p.variant_id + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="w-full rounded-full bg-secondary text-secondary-foreground hover:bg-secondary/90 hover:-translate-y-0.5 transition-all font-medium text-sm h-10">Acheter maintenant</button></form>' +
          '</div>';
        }).join("");
        qBody.innerHTML =
          '<div class="grid gap-8 ' + (handles.length > 1 ? "sm:grid-cols-2 lg:grid-cols-3" : "max-w-sm mx-auto") + '">' + cards + '</div>' +
          '<div class="text-center mt-12 flex flex-wrap gap-4 justify-center">' +
            '<button data-quiz-restart data-testid="quiz-restart" class="rounded-full border border-primary/30 h-12 px-7 inline-flex items-center gap-2">↻ Recommencer</button>' +
            '<a href="/collections/all" class="rounded-full bg-secondary text-secondary-foreground h-12 px-7 inline-flex items-center">Voir toute la boutique</a>' +
          '</div>';
        var rs = qBody.querySelector("[data-quiz-restart]");
        if (rs) rs.addEventListener("click", function () { state = { step: 0, scores: {}, finished: false }; render(); window.scrollTo({ top: 0, behavior: "smooth" }); });
      }
    }

    function choose(opt, weight) {
      (opt.needs || []).forEach(function (s) { state.scores[s] = (state.scores[s] || 0) + weight; });
      if (state.step < steps.length - 1) { state.step++; } else { state.finished = true; }
      render();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    render();
  })();

  /* ---------- copy referral link ---------- */
  $all("[data-copy]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var val = btn.getAttribute("data-copy");
      if (navigator.clipboard) navigator.clipboard.writeText(val).then(function () { toast("Lien copié !"); });
    });
  });

  onScroll();
})();
